/* tslint:disable */
/* eslint-disable */
/**
 * WAG TP Request API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    WAGTPRequest,
    WAGTPRequestFromJSON,
    WAGTPRequestFromJSONTyped,
    WAGTPRequestToJSON,
} from './';

/**
 * 
 * @export
 * @interface BodyTpRequestTpRequestPost
 */
export interface BodyTpRequestTpRequestPost {
    /**
     * 
     * @type {WAGTPRequest}
     * @memberof BodyTpRequestTpRequestPost
     */
    request: WAGTPRequest;
}

export function BodyTpRequestTpRequestPostFromJSON(json: any): BodyTpRequestTpRequestPost {
    return BodyTpRequestTpRequestPostFromJSONTyped(json, false);
}

export function BodyTpRequestTpRequestPostFromJSONTyped(json: any, ignoreDiscriminator: boolean): BodyTpRequestTpRequestPost {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'request': WAGTPRequestFromJSON(json['request']),
    };
}

export function BodyTpRequestTpRequestPostToJSON(value?: BodyTpRequestTpRequestPost | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'request': WAGTPRequestToJSON(value.request),
    };
}


